function flatKey(value) {
  return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, '');
}

export function indexDex(dex) {
  const byKey = new Map();
  const remember = (key, entry) => {
    const text = String(key || '').toLowerCase();
    if (!text || byKey.has(text)) return;
    byKey.set(text, entry);
    const folded = flatKey(text);
    if (folded && !byKey.has(folded)) byKey.set(folded, entry);
  };
  [...(dex?.pokemon || []), ...(dex?.formes || [])].forEach((entry) => {
    [entry.slug, entry.name, ...(entry.aliases || [])].forEach((key) => remember(key, entry));
  });
  return byKey;
}

export function findDexEntry(dex, key) {
  const text = String(key || '').trim().toLowerCase();
  if (!text || !dex) return null;
  if (/^\d+$/.test(text)) {
    const id = Number(text);
    return (dex.pokemon || []).find((entry) => entry.id === id && !entry.mega && !entry.primal) || null;
  }
  const byKey = dex.byKey || indexDex(dex);
  return byKey.get(text) || byKey.get(flatKey(text)) || null;
}

// Compare cards use PokéAPI's decimeter and hectogram fields. The published
// dex stores meters and kilograms, which is the same measurement.
export function toComparePokemon(entry) {
  return {
    id: entry.id,
    slug: entry.slug,
    name: entry.name,
    mega: Boolean(entry.mega),
    primal: Boolean(entry.primal),
    height: typeof entry.heightM === 'number' ? Math.round(entry.heightM * 10) : 0,
    weight: typeof entry.weightKg === 'number' ? Math.round(entry.weightKg * 10) : 0,
    sprite: entry.sprite || null,
    types: entry.types || [],
    abilities: entry.abilities || [],
    stats: entry.stats,
    total: entry.total,
  };
}
